// This import loads the firebase namespace along with all its type information.
import ChangeLog from './change-log-model'

export async function load_changeLogs(): Promise<ChangeLog[]> {
  throw 'Not implemented'
}

export async function delete_changeLog(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_changeLog(): Promise<ChangeLog> {
  throw 'Not implemented'
}
